<script setup>
import { ref, computed, onBeforeMount } from "vue";
import { useCompanyStore } from "@/stores/company";
import { useUiStore } from "@/stores/ui";
import { useUrlsStore } from "@/stores/urls";

const uiStore = useUiStore();
const urlsStore = useUrlsStore();
const emit = defineEmits(["refresh"]);
const company_id = useCompanyStore().companyId;
let id = ref(null);
let name = ref(null);
let url = ref(null);
let depth = ref(null);
let description = ref(null);
let isSubmitted = ref(false);
const getModalAction = computed(() => uiStore.modalAction);

const onSubmit = () => {
  isSubmitted.value = true;
  const data = {
    id: id.value,
    company_id,
    data: {
      name: name.value,
      url: url.value,
      description: description.value,
      depth: depth.value,
    },
  };

  urlsStore
    .editUrl(data)
    .then(() => {
      resetStoreData();
      emit("refresh");
    })
    .catch(() => {
      isSubmitted.value = false;
    });
};

const resetStoreData = () => {
  uiStore.resetModalStore();
};

onBeforeMount(() => {
  if (uiStore.modalData && uiStore.modalAction == "edit_url") {
    id.value = uiStore.modalData.id;
    name.value = uiStore.modalData.name;
    url.value = uiStore.modalData.url;
    description.value = uiStore.modalData.description;
  }
});
</script>

<template>
  <DModal v-if="getModalAction === 'edit_url'" :visible="uiStore.modalState" @update:visible="val => { if (!val) resetStoreData() }" :main_classes="[]" :dialog_classes="[]">
    <template #title> Edit Websit </template>

    <template #body>
      <div class="mb-3">
        <DInput
          label="URL Name"
          :value="name"
          @input="name = $event.target.value"
          type="text"
          width="100%"
        />
      </div>

      <div class="mb-3">
        <DInput
          label="URL"
          :value="url"
          @input="url = $event.target.value"
          type="text"
          width="100%"
        />
      </div>

      <FloatLabel class="w-full mb-3">
        <PTextarea
          v-model="description"
          id="editDescription"
          class="d-textarea resize-none h-105 w-full"
          autoResize
        />
        <label for="editDescription">Description</label>
      </FloatLabel>
    </template>
    <template #footer>
      <div class="w-full">
        <div class="seperator text-center"></div>
        <div class="flex mt-20 justify-center">
          <button
            :disabled="!name || isSubmitted"
            @click="onSubmit"
            type="button"
            class="btn btn-primary add-button mr-30"
          >
            Edit
            <span
              v-if="isSubmitted"
              class="spinner-sm"
              role="status"
              aria-hidden="true"
            ></span>
          </button>
          <button
            @click="resetStoreData"
            type="button"
            class="btn btn-secondary cancel-button"

          >
            Cancel
          </button>
        </div>
      </div>
    </template>
  </DModal>
</template>
